/* =========================================================
   OTTR — the saved list.

   Loaded on every page from snippets/stylesheets.liquid. It has to be
   site-wide: the heart is in the header, on shelf cards and on the buy
   page, not only on /pages/wishlist. A section's {% javascript %} bundle
   is NOT enough — it is only served on pages where that section renders,
   verified by window.OttrWish coming back undefined on the buy page.

   Storage is localStorage on the visitor's own device. No app, no customer
   account, no metafield. Product data comes from Shopify's own
   /products/<handle>.js, so a price or a photograph can never go stale.

   A row carries no Add to cart button. The variant id rides along on a
   hidden [data-wl-one] span so Add all can still collect them; buying one
   thing is a tap through to the product, which is quieter and the same
   number of taps.
   ========================================================= */
(function () {
  if (window.OttrWish) return;

  var KEY = 'ottr:wish';
  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M12 20.4 4.6 13a4.85 4.85 0 0 1 6.86-6.86l.54.54.54-.54A4.85 4.85 0 0 1 19.4 13Z" stroke-linejoin="round"/></svg>';

  function read() {
    try { var v = JSON.parse(localStorage.getItem(KEY)); return Array.isArray(v) ? v : []; }
    catch (e) { return []; }
  }
  function write(a) {
    try { localStorage.setItem(KEY, JSON.stringify(a)); } catch (e) {}
    document.dispatchEvent(new CustomEvent('ottr:wish', { detail: { list: a } }));
  }
  function has(h) { return read().indexOf(h) > -1; }
  function add(h) { var a = read(); if (a.indexOf(h) < 0) { a.push(h); write(a); } }
  function remove(h) { write(read().filter(function (x) { return x !== h; })); }
  function toggle(h) { var on = !has(h); on ? add(h) : remove(h); return on; }

  window.OttrWish = { read: read, has: has, add: add, remove: remove, toggle: toggle };

  function inr(paise) { return '₹' + Math.round(paise / 100).toLocaleString('en-IN'); }

  var cache = {};
  function product(h) {
    if (!cache[h]) {
      cache[h] = fetch('/products/' + encodeURIComponent(h) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[h];
  }

  function handleOf(href) {
    var m = String(href || '').match(/\/products\/([^/?#]+)/);
    return m ? m[1] : '';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }

  /* ---------- the header icon ----------
     It ships from sections/ottr-head.liquid with the count hidden, because
     the list lives in this browser and Liquid cannot see it. */
  function syncHeader() {
    var n = read().length;
    Array.prototype.forEach.call(document.querySelectorAll('.icons a.wish'), function (a) {
      a.classList.toggle('is-on', n > 0);
      var b = a.querySelector('b');
      if (b) { b.textContent = n; b.hidden = n === 0; }
      a.setAttribute('aria-label', n
        ? 'Saved list, ' + n + ' item' + (n === 1 ? '' : 's')
        : 'Saved list');
    });
  }

  /* ---------- the save buttons, wherever they are ---------- */

  function paint(btn) {
    var on = has(btn.getAttribute('data-wish'));
    btn.classList.toggle('is-on', on);
    btn.setAttribute('aria-pressed', on ? 'true' : 'false');
    var name = btn.getAttribute('data-wish-name') || 'this';
    btn.setAttribute('aria-label', (on ? 'Saved. Remove ' : 'Save ') + name + (on ? ' from' : ' to') + ' your list');
    var label = btn.querySelector('span');
    if (label) label.textContent = on ? 'Saved' : 'Save for later';
  }
  function paintAll() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-wish]'), paint);
    syncHeader();
  }

  /* Shelf cards. article.prod is the shelf's own markup — blocks/ottr-shelf.liquid. */
  function armCards() {
    Array.prototype.forEach.call(document.querySelectorAll('article.prod'), function (card) {
      if (card.querySelector('.wl-heart')) return;
      var a = card.querySelector('a[href*="/products/"]');
      var h = a && handleOf(a.getAttribute('href'));
      if (!h) return;
      var nm = card.querySelector('.nm');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'wl-heart';
      b.setAttribute('data-wish', h);
      b.setAttribute('data-wish-name', nm ? nm.textContent.trim() : 'this');
      b.innerHTML = HEART;
      paint(b);
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
      card.appendChild(b);
    });
  }

  /* The buy page. Drop a [data-wish-slot] element where it should sit;
     otherwise it lands after the product form, in normal flow. */
  function armBuy() {
    if (document.querySelector('.wl-save')) return;
    var h = handleOf(location.pathname);
    if (!h) return;

    var slot = document.querySelector('[data-wish-slot]');
    var form = document.querySelector('product-form-component, form[action*="/cart/add"]');
    if (!slot && !form) return;

    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'wl-save';
    b.setAttribute('data-wish', h);
    b.setAttribute('data-wish-name', (document.querySelector('h1') || {}).textContent || 'this');
    b.innerHTML = HEART + '<span>Save for later</span>';
    paint(b);
    if (slot) slot.appendChild(b);
    else form.insertAdjacentElement('afterend', b);
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest ? e.target.closest('[data-wish]') : null;
    if (!b) return;
    e.preventDefault();
    e.stopPropagation();
    toggle(b.getAttribute('data-wish'));
  });

  /* ---------- the board ---------- */

  var root = null;
  var sharedParam = null;
  try { sharedParam = new URLSearchParams(location.search).get('list'); } catch (e) {}

  function q(sel) { return root ? root.querySelector(sel) : null; }
  function all(sel) { return root ? Array.prototype.slice.call(root.querySelectorAll(sel)) : []; }

  function toast(msg) {
    var t = q('[data-wl-toast]');
    if (!t) return;
    t.textContent = msg;
    t.hidden = false;
    clearTimeout(t._h);
    t._h = setTimeout(function () { t.hidden = true; }, 2600);
  }

  function sharedList() {
    return sharedParam ? sharedParam.split(',').map(function (x) { return x.trim(); }).filter(Boolean) : null;
  }

  function render() {
    root = document.querySelector('[data-wl]');
    if (!root) return;
    var shared = sharedList();
    var list = shared || read();
    var items = q('[data-wl-items]');
    var empty = q('[data-wl-empty]');
    if (!items) return;

    var banner = q('[data-wl-shared]');
    if (banner) {
      banner.hidden = !shared;
      var n = q('[data-wl-sharedn]');
      if (n && shared) n.textContent = shared.length + (shared.length === 1 ? ' item.' : ' items.');
    }

    if (!list.length) {
      items.innerHTML = '';
      if (empty) empty.hidden = false;
      all('[data-wl-bar], [data-wl-sum]').forEach(function (el) { el.hidden = true; });
      return;
    }
    if (empty) empty.hidden = true;

    Promise.all(list.map(product)).then(function (rows) {
      var total = 0, live = 0, html = '';

      rows.forEach(function (p, i) {
        var h = list[i];
        if (!p) return;
        live++;
        var v = (p.variants || []).filter(function (x) { return x.available; })[0] || (p.variants || [])[0];
        var price = v ? v.price : p.price;
        if (v && v.available) total += price;
        var img = p.featured_image || (p.images && p.images[0]);
        var was = v && v.compare_at_price && v.compare_at_price > price
          ? '<span class="wl__was">' + inr(v.compare_at_price) + '</span>' : '';

        html += '<li class="wl__it">'
          + '<a class="wl__ph" href="' + esc(p.url) + '" tabindex="-1" aria-hidden="true">'
          + (img ? '<img src="' + esc(img) + '&width=400" alt="" loading="lazy">' : '')
          + '</a>'
          + '<div class="wl__tx">'
          + '<a class="wl__nm" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'
          + '<p class="wl__pr">' + inr(price) + was + '</p>'
          + (v && v.available ? '' : '<p class="wl__st">Out of stock</p>')
          + '</div>'
          + (shared ? '' : '<button type="button" class="wl__rm" data-wl-rm="' + esc(h) + '" aria-label="Remove ' + esc(p.title) + ' from your list">✕</button>')
          + (v && v.available ? '<span hidden data-wl-one="' + v.id + '"></span>' : '')
          + '</li>';
      });

      items.innerHTML = html;

      all('[data-wl-count]').forEach(function (el) { el.textContent = live; });
      all('[data-wl-total]').forEach(function (el) { el.textContent = total ? inr(total) : '—'; });
      all('[data-wl-sum]').forEach(function (el) { el.hidden = !live; });
      var bar = q('[data-wl-bar]');
      if (bar) bar.hidden = !live;
    });
  }

  function addToCart(ids) {
    if (!ids.length) return;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: ids.map(function (id) { return { id: id, quantity: 1 }; }) })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      location.href = '/cart';
    }).catch(function () {
      toast('That did not go through. Try again?');
    });
  }

  document.addEventListener('click', function (e) {
    if (!root || !e.target.closest) return;
    var t = e.target;
    if (!root.contains(t)) return;

    var rm = t.closest('[data-wl-rm]');
    if (rm) { remove(rm.getAttribute('data-wl-rm')); return; }

    if (t.closest('[data-wl-addall]')) {
      var ids = all('[data-wl-one]').map(function (b) { return b.getAttribute('data-wl-one'); });
      if (!ids.length) { toast('Nothing on the list is in stock right now.'); return; }
      addToCart(ids);
      return;
    }

    if (t.closest('[data-wl-adopt]')) {
      var s = sharedList() || [];
      var mine = read();
      s.forEach(function (h) { if (mine.indexOf(h) < 0) mine.push(h); });
      write(mine);
      sharedParam = null;
      try { history.replaceState({}, '', location.pathname); } catch (err) {}
      render();
      toast('Saved to your list.');
      return;
    }

    if (t.closest('[data-wl-share]')) {
      var listNow = read();
      if (!listNow.length) { toast('Save something first.'); return; }
      var url = location.origin + location.pathname + '?list=' + listNow.join(',');
      /* A phone has a share sheet and it is better than anything we could build. */
      if (navigator.share) {
        navigator.share({ title: 'My Ottr list', url: url }).catch(function () {});
      } else if (navigator.clipboard) {
        navigator.clipboard.writeText(url).then(function () {
          toast('Link copied.');
        }).catch(function () { prompt('Copy this link', url); });
      } else {
        prompt('Copy this link', url);
      }
    }
  });

  /* ---------- wiring ---------- */

  function arm() { armCards(); armBuy(); paintAll(); }

  document.addEventListener('ottr:wish', function () { paintAll(); render(); });
  document.addEventListener('shopify:section:load', function () { arm(); render(); });
  window.addEventListener('pageshow', arm);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { arm(); render(); });
  } else {
    arm(); render();
  }
  /* Sections on this theme hydrate after first paint. */
  setTimeout(function () { arm(); render(); }, 700);
  setTimeout(function () { arm(); render(); }, 2200);
})();
